import { useNavigate } from "react-router-dom";
import { Icon } from "@components/index";
import { toastService } from "@utils/index";
import { useAppConfig } from "@context/AppConfigContext";
import { useTopbar } from "./topbarData";
import "./index.scss";

const Topbar = ({ onMenuToggle, sidebarOpen }) => {
  const navigate = useNavigate();
  const { user } = useAppConfig();

  // Use comprehensive topbar hook that manages all logic
  const {
    userMenuOpen,
    userMenuRef,
    handleUserMenuToggle,
    handleMenuToggle,
    handleMenuItemClick,
    userGreeting,
    config,
    menuItems,
  } = useTopbar(onMenuToggle, sidebarOpen, navigate, toastService, user);

  // Render dropdown item
  const renderDropdownItem = (item) => {
    if (item.type === "divider") {
      return <hr key={item.id} className="topbar__dropdown-divider" />;
    }

    return (
      <button
        key={item.id}
        className="topbar__dropdown-item"
        onClick={() => handleMenuItemClick(item.action)}
        type="button"
      >
        {item.icon && (
          <Icon
            iconName={item.icon}
            height={16}
            width={16}
            className="topbar__dropdown-icon"
          />
        )}
        <span>{item.label}</span>
      </button>
    );
  };

  return (
    <header className="topbar">
      <div className="topbar__left">
        {/* Hello , roleType */}
        <button
          className="topbar__menu-toggle"
          onClick={handleMenuToggle}
          aria-label={config.menuToggleLabel}
          type="button"
        >
          <span className="topbar__menu-icon">
            <Icon iconName="hamburger" height={32} width={32} />
          </span>
        </button>
      </div>

      <div className="topbar__right">
        {userGreeting && (
          <div className="topbar__user-greeting">
            <span className="topbar__greeting-text">{userGreeting}</span>
          </div>
        )}
        <div className="topbar__actions">
          <div className="topbar__user-menu" ref={userMenuRef}>
            <button
              className="topbar__user-btn"
              onClick={handleUserMenuToggle}
              aria-label={config.userMenuLabel}
              type="button"
            >
              <div className="topbar__user-avatar">
                <Icon
                  iconName={config.avatarIcon}
                  height={config.avatarSize}
                  width={config.avatarSize}
                />
              </div>
            </button>

            {userMenuOpen && (
              <div className="topbar__user-dropdown">
                {menuItems.map(renderDropdownItem)}
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Topbar;
